import React from "react";
import { Desktop } from "../containers/common";
import { Switch, Route, useRouteMatch } from "react-router-dom";

//screens
import {
  SpeedShoppingHome,
  SpeedShoppingCatalogueHome,
  SpeedShoppingCart,
  SpeedShoppingPickup,
  SpeedShoppingFaq,
  SpeedShoppingOrders,
  SpeedShoppingOrderDetails,
  SpeedShoppingPoints,
  SpeedShoppingLeaderboard,
} from "../screens/subscriber/speedShopping";
import { MashupnWinLeaderboard } from "../screens/subscriber/mashupnwin";

const SpeedShopping = () => {
  const match = useRouteMatch();
  return (
    <>
      <Desktop phonebg={"white"}>
        <Switch>
          <Route
            path={`${match.path}/cataloguehome`}
            render={() => <SpeedShoppingCatalogueHome />}
          />
          <Route
            path={`${match.path}/cart`}
            render={() => <SpeedShoppingCart />}
          />
          <Route
            path={`${match.path}/pickup`}
            render={() => <SpeedShoppingPickup />}
          />
          <Route
            path={`${match.path}/faq`}
            render={() => <SpeedShoppingFaq />}
          />
          <Route
            path={`${match.path}/orders`}
            render={() => <SpeedShoppingOrders />}
          />
          <Route
            path={`${match.path}/points`}
            render={() => <SpeedShoppingPoints />}
          />
          <Route
            path={`${match.path}/leaderboard`}
            render={() => <SpeedShoppingLeaderboard />}
          />
          <Route
            path={`${match.path}/order-details/:orderId`}
            render={() => <SpeedShoppingOrderDetails />}
          />
          <Route path={`${match.path}`} render={() => <SpeedShoppingHome />} />
        </Switch>
      </Desktop>
    </>
  );
};

export default SpeedShopping;
